import Flex from 'components/ui/Flex';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { ReturnStatusType } from 'returnCenter-api';
import ActionButton from 'components/ui/ActionButton';
import useAppSelector from 'hooks/useAppSelector';
import { returnSelectors } from 'store/reducers/returnSlice';
import SaveChangesButton from './SaveAction';
import CompleteReturn from './CompleteReturn';

type NewReturnActionsProps = {
    onSaveWithStatus: (status: ReturnStatusType) => void;
    isLoading?: boolean;
    onComplete: () => void;
    isCompleted?: boolean;
};

const NewReturnActions: React.FC<NewReturnActionsProps> = ({
    onSaveWithStatus,
    isLoading,
    onComplete,
    isCompleted,
}) => {
    const { t } = useTranslation();
    const buttonStates = useAppSelector(returnSelectors.selectReturnButtonStates);

    const canSave = buttonStates.canSave;

    return (
        <Flex column gap="1rem">
            <Panel column gap="0.5rem">
                <NextStepLabel>{t('nextStepInFlow', 'Gå vidare i processen')}</NextStepLabel>
                <ActionButton
                    label={`${t('markAs', 'Markera som')} ${t('statusIncomingPackage', t('incomingPackage'))}`}
                    onClick={() => onSaveWithStatus(ReturnStatusType.IncomingPackage)}
                    disabled={!canSave}
                    isLoading={isLoading}
                    title={t('incomingPackageTooltip')}
                    fullWidth
                    main
                    rounded
                />
            </Panel>

            <Panel column gap="0.5rem">
                <SaveChangesButton
                    onClick={() => onSaveWithStatus(ReturnStatusType.Created)}
                    disabled={isCompleted || !buttonStates.canSave}
                    isLoading={buttonStates.isLoading}
                    label={t('createReturn', 'Create return')}
                    title={t('saveChangesTooltip')}
                />

                <CompleteReturn
                    onComplete={onComplete}
                    disabled={isCompleted || !buttonStates.canComplete}
                    isLoading={buttonStates.isLoading}
                />
            </Panel>
        </Flex>
    );
};

export default NewReturnActions;

const Panel = styled(Flex)`
    background: ${({ theme }) => theme.colors.fillWhite};
    border-radius: var(--radius);
    padding: 1rem;
`;

const NextStepLabel = styled.span`
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.textFaded};
`;
